import * as React from "react";
const SvgIconArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", fill: "#5f6368", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M440-80v-647L256-544l-56-56 280-280 280 280-56 57-184-184v647h-80Z" }));
export default SvgIconArrowUp;
